import { Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { IconComponent } from '../../icons/icon/icon.component';

@Component({
  selector: 'ui-back-button',
  templateUrl: './back-button.component.html',
  standalone: true,
  imports: [IconComponent, RouterLink],
})
export class BackButtonComponent {
  readonly link = input.required<string>();
  readonly label = input<string>('Back');
}
